import { getAuthToken } from "../api/login-service";
import { getUserInfo, isNotEmptyOrNull } from "../utils/common-utils";
import { StorageService } from "../utils/StorageUtils";
import { axiosInstance } from "./NetworkConfig";

export const getHeaders = async (existingHeaders) => {
  let token = await getAuthToken();
  let headers = { ...existingHeaders };
  headers["Content-Type"] = "application/json";
  if (isNotEmptyOrNull(StorageService.getItem("xUserId"))) {
    headers["x-user-id"] = StorageService.getItem("xUserId");
  } else {
    console.log("getHeaders call");
  }
  headers["Authorization"] = token;
  headers = { ...headers };
  return headers;
};
// GET Request
export const get = async (endpoint, options = {}) => {
  try {
    let headers = { ...(options.headers || {}) };
    let updatedHeaders = await getHeaders(headers);
    options = { ...options, headers: updatedHeaders };
    console.log("options", options);
    const response = await axiosInstance().get(endpoint, options);
    return response;
  } catch (error) {
    console.log(error);
    return error;
  }
};

// POST Request
export const post = async (endpoint, data, options = {}) => {
  try {
    let headers = { ...(options.headers || {}) };
    let updatedHeaders = await getHeaders(headers);
    options = { ...options, headers: updatedHeaders };
    console.log("options", options);
    const response = await axiosInstance().post(endpoint, data, options);
    return response;
  } catch (error) {
    console.log(error);
    return error;
  }
};

export const patch = async (endpoint, data, options = {}) => {
  try {
    let headers = { ...(options.headers || {}) };
    let updatedHeaders = await getHeaders(headers);
    options = { ...options, headers: updatedHeaders };
    console.log("options", options);
    const response = await axiosInstance().patch(endpoint, data, options);
    return response;
  } catch (error) {
    console.log(error);
    return error;
  }
};

async function callApi(
  endpoint,
  method,
  body,
  options,
  { APIClient = defaultAPIClient } = {}
) {
  try {
    if (endpoint === "/global-auth/v1/student/refresh-token") {
      let userInfo = await getUserInfo();
      APIClient.defaults.headers.common["refreshtoken"] =
        userInfo?.refreshToken;
      APIClient.defaults.headers["Authorization"] = userInfo?.accessToken;
      APIClient.defaults.headers["x-user-id"] =
        StorageService.getItem("xUserid");
    } else {
      let authToken = await getAuthToken();
      APIClient.defaults.headers["Authorization"] = authToken;
      APIClient.defaults.headers["x-user-id"] =
        StorageService.getItem("xUserid");
    }

    const response = await APIClient.request({
      url: `${window.ENV.TUTOR_API_URL}` + endpoint,
      method: method,
      data: body,
      ...options,
    });

    const { data } = response;
    if (response.success) {
      return { success: true, data };
    } else {
      if (response?.statusCode === 401) {
        getAuthToken(true);
      }
      return {
        success: false,
        errorMessage: response?.errors || "",
        statusCode: response?.statusCode,
      };
    }
  } catch (error) {
    return Promise.reject(error);
  }
}
